import { defaultOutreachSettings } from '../utils/outreachEmailBody';
import { isRichTextEmpty } from '../components/Reusables/RichText/richTextConfig';

export const EWS_COMPANY_ID = '6a3ba48717564c005587e06a';

const LOGO_URL =
	'https://extrawebsolutions.co.uk/wp-content/uploads/2026/09/EWS-logo-trans-1.png';

/** HTML signature for Extra Web Solutions (matches branded Gmail signature). */
export const EWS_OUTREACH_SIGNATURE_HTML = `<p style="margin:0 0 10px;font-size:16px;">Thank you,</p>
<p style="margin:0 0 16px;font-size:16px;">Kind regards,</p>
<table cellpadding="0" cellspacing="0" border="0" style="font-family:Arial,Helvetica,sans-serif;font-size:16px;line-height:1.5;color:#1e293b;max-width:680px;">
  <tr>
    <td style="border-left:6px solid #c45c5c;padding:8px 20px 8px 14px;vertical-align:middle;">
      <img src="${LOGO_URL}" alt="Extra Web Solutions" width="148" style="display:block;border:0;width:148px;max-width:148px;height:auto;" />
    </td>
    <td style="border-left:1px solid #e5e7eb;padding:8px 0 8px 22px;vertical-align:top;">
      <div style="font-size:24px;font-weight:700;color:#1e3a5f;line-height:1.2;">Aury Silva</div>
      <div style="font-size:15px;color:#6b7280;margin:5px 0 14px;">Founder &amp; Lead Developer</div>
      <table cellpadding="0" cellspacing="0" border="0" style="font-size:15px;line-height:1.7;">
        <tr>
          <td style="padding-right:24px;vertical-align:top;">
            <span style="color:#c45c5c;font-weight:700;">M</span> 074482 69948<br />
            <span style="color:#c45c5c;font-weight:700;">T</span> 01482 212499
          </td>
          <td style="vertical-align:top;">
            <span style="color:#c45c5c;font-weight:700;">E</span> aury@extrawebsolutions.co.uk<br />
            <span style="color:#c45c5c;font-weight:700;">W</span> <a href="https://www.extrawebsolutions.co.uk/" style="color:#c45c5c;text-decoration:none;">www.extrawebsolutions.co.uk</a>
          </td>
        </tr>
      </table>
    </td>
  </tr>
  <tr>
    <td colspan="2" style="padding-top:14px;border-top:3px solid #e5e7eb;">
      <div style="font-size:14px;color:#9ca3af;margin-bottom:8px;">
        <a href="https://www.facebook.com/extra.web.solutions/" style="color:#9ca3af;text-decoration:none;">Facebook</a>
        &nbsp;|&nbsp;
        <a href="https://www.linkedin.com/company/extra-web-solutions" style="color:#9ca3af;text-decoration:none;">LinkedIn</a>
      </div>
      <div style="font-size:14px;font-weight:700;color:#9ca3af;">Custom solutions to fix your operational workflow.</div>
    </td>
  </tr>
</table>`;

export const getDefaultOutreachSettingsForCompany = (companyId) => {
	if (String(companyId) === EWS_COMPANY_ID) {
		return {
			appendSignature: true,
			signature: EWS_OUTREACH_SIGNATURE_HTML,
		};
	}
	return defaultOutreachSettings();
};

/** Merges saved company settings with coded defaults for known companies. */
export const resolveOutreachSettings = (companyId, saved) => {
	const defaults = getDefaultOutreachSettingsForCompany(companyId);
	const merged = { ...defaults, ...(saved || {}) };
	if (saved?.signature && !isRichTextEmpty(saved.signature)) {
		merged.signature = saved.signature;
		if (saved.appendSignature !== undefined) {
			merged.appendSignature = saved.appendSignature;
		}
	} else if (defaults.signature) {
		merged.signature = defaults.signature;
		merged.appendSignature = defaults.appendSignature ?? true;
	}
	return merged;
};
